import { classNames, h } from "omi";

import { NWIcon } from "@/wc/components/atoms/nw-icon";

import { type Option } from "../../models";

export function ReasonSection({ option, key }: { option: Option | undefined; key: string }) {
  if (option == null) {
    return null;
  }

  const isCorrect = option.isAnswer ?? false;

  return (
    <div className="flex flex-col sm:flex-row gap-8 justify-around items-center w-full rounded-2xl bg-primary px-6 py-4">
      <div
        className={classNames("border bg-white space-y-3 px-4 py-2 text-sm w-2/3 rounded-xl", {
          "border-success-300": isCorrect,
          "border-error-300": !isCorrect,
        })}
      >
        <div className="flex flex-row items-center justify-between">
          <p className="text-primary font-bold">
            Why <span className={classNames("border rounded-lg px-1.5 py-0.5 mx-0.5")}>{key}</span> is{" "}
            {isCorrect ? "correct" : "incorrect"}:
          </p>

          <div
            class={classNames("p-2 bg-error-100 rounded-full w-fit flex-grow-0", {
              "bg-success-100": isCorrect,
              "bg-error-100": !isCorrect,
            })}
          >
            {isCorrect && <NWIcon name="tick" className="text-success-300"></NWIcon>}
            {!isCorrect && <NWIcon name="cross" className="text-error-300"></NWIcon>}
          </div>
        </div>

        <p className="text-secondary">{option.explanation}</p>
      </div>
    </div>
  );
}
